/* tslint:disable */
/* eslint-disable */
/**
 * Assisted Webservices
 * Enables agents to provide real-time support to customers. For example, agents are able to find a customer account or cart, bind anonymous carts to customer accounts, and provide different customer lists relative to different business applications.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { B2BUnit } from './B2BUnit';
import {
    B2BUnitFromJSON,
    B2BUnitFromJSONTyped,
    B2BUnitToJSON,
} from './B2BUnit';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';
import type { Language } from './Language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
} from './Language';
import type { UserAvatar } from './UserAvatar';
import {
    UserAvatarFromJSON,
    UserAvatarFromJSONTyped,
    UserAvatarToJSON,
} from './UserAvatar';

/**
 * Representation of a User
 * @export
 * @interface User
 */
export interface User {
    /**
     * Unique user identifier
     * @type {string}
     * @memberof User
     */
    uid?: string;
    /**
     * Name of the user
     * @type {string}
     * @memberof User
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    orgUnitId?: string;
    /**
     * 
     * @type {Address}
     * @memberof User
     */
    defaultAddress?: Address;
    /**
     * User title code
     * @type {string}
     * @memberof User
     */
    titleCode?: string;
    /**
     * User title
     * @type {string}
     * @memberof User
     */
    title?: string;
    /**
     * User first name
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * User last name
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * 
     * @type {Currency}
     * @memberof User
     */
    currency?: Currency;
    /**
     * 
     * @type {Language}
     * @memberof User
     */
    language?: Language;
    /**
     * User identifier
     * @type {string}
     * @memberof User
     */
    displayUid?: string;
    /**
     * Customer identifier
     * @type {string}
     * @memberof User
     */
    customerId?: string;
    /**
     * Deactivation date
     * @type {Date}
     * @memberof User
     */
    deactivationDate?: Date;
    /**
     * Name of the default pick up location
     * @type {string}
     * @memberof User
     */
    defaultPointOfServiceName?: string;
    /**
     * The latest cart operated by customer
     * @type {string}
     * @memberof User
     */
    lastCartId?: string;
    /**
     * Indicates whether customer has order. Default value is false.
     * @type {boolean}
     * @memberof User
     */
    hasOrder?: boolean;
    /**
     * 
     * @type {UserAvatar}
     * @memberof User
     */
    userAvatar?: UserAvatar;
    /**
     * 
     * @type {B2BUnit}
     * @memberof User
     */
    orgUnit?: B2BUnit;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    roles?: Array<string>;
    /**
     * List of organizational approvers
     * @type {Array<User>}
     * @memberof User
     */
    approvers?: Array<User>;
    /**
     * Boolean flag of whether the user is selected
     * @type {boolean}
     * @memberof User
     */
    selected?: boolean;
    /**
     * Boolean flag of whether the user is active/enabled or not
     * @type {boolean}
     * @memberof User
     */
    active?: boolean;
    /**
     * Email of the user
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    municipalityId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    customerType?: UserCustomerTypeEnum;
    /**
     * 
     * @type {Address}
     * @memberof User
     */
    contactAddress?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    positiveListAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    customerStatGroup1?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    customerStatGroup2?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    market?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    allowOnetimeAddress?: boolean;
    /**
     * 
     * @type {Array<B2BUnit>}
     * @memberof User
     */
    orgUnits?: Array<B2BUnit>;
}


/**
 * @export
 */
export const UserCustomerTypeEnum = {
    B2C: 'B2C',
    B2B: 'B2B',
    Guest: 'GUEST',
    Employee: 'EMPLOYEE'
} as const;
export type UserCustomerTypeEnum = typeof UserCustomerTypeEnum[keyof typeof UserCustomerTypeEnum];


/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'orgUnitId': !exists(json, 'orgUnitId') ? undefined : json['orgUnitId'],
        'defaultAddress': !exists(json, 'defaultAddress') ? undefined : AddressFromJSON(json['defaultAddress']),
        'titleCode': !exists(json, 'titleCode') ? undefined : json['titleCode'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'currency': !exists(json, 'currency') ? undefined : CurrencyFromJSON(json['currency']),
        'language': !exists(json, 'language') ? undefined : LanguageFromJSON(json['language']),
        'displayUid': !exists(json, 'displayUid') ? undefined : json['displayUid'],
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'deactivationDate': !exists(json, 'deactivationDate') ? undefined : (new Date(json['deactivationDate'])),
        'defaultPointOfServiceName': !exists(json, 'defaultPointOfServiceName') ? undefined : json['defaultPointOfServiceName'],
        'lastCartId': !exists(json, 'lastCartId') ? undefined : json['lastCartId'],
        'hasOrder': !exists(json, 'hasOrder') ? undefined : json['hasOrder'],
        'userAvatar': !exists(json, 'userAvatar') ? undefined : UserAvatarFromJSON(json['userAvatar']),
        'orgUnit': !exists(json, 'orgUnit') ? undefined : B2BUnitFromJSON(json['orgUnit']),
        'roles': !exists(json, 'roles') ? undefined : json['roles'],
        'approvers': !exists(json, 'approvers') ? undefined : ((json['approvers'] as Array<any>).map(UserFromJSON)),
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'municipalityId': !exists(json, 'municipalityId') ? undefined : json['municipalityId'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'customerType': !exists(json, 'customerType') ? undefined : json['customerType'],
        'contactAddress': !exists(json, 'contactAddress') ? undefined : AddressFromJSON(json['contactAddress']),
        'positiveListAvailable': !exists(json, 'positiveListAvailable') ? undefined : json['positiveListAvailable'],
        'customerStatGroup1': !exists(json, 'customerStatGroup1') ? undefined : json['customerStatGroup1'],
        'customerStatGroup2': !exists(json, 'customerStatGroup2') ? undefined : json['customerStatGroup2'],
        'market': !exists(json, 'market') ? undefined : json['market'],
        'allowOnetimeAddress': !exists(json, 'allowOnetimeAddress') ? undefined : json['allowOnetimeAddress'],
        'orgUnits': !exists(json, 'orgUnits') ? undefined : ((json['orgUnits'] as Array<any>).map(B2BUnitFromJSON)),
    };
}

export function UserToJSON(value?: User | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
        'name': value.name,
        'orgUnitId': value.orgUnitId,
        'defaultAddress': AddressToJSON(value.defaultAddress),
        'titleCode': value.titleCode,
        'title': value.title,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'currency': CurrencyToJSON(value.currency),
        'language': LanguageToJSON(value.language),
        'displayUid': value.displayUid,
        'customerId': value.customerId,
        'deactivationDate': value.deactivationDate === undefined ? undefined : (value.deactivationDate.toISOString()),
        'defaultPointOfServiceName': value.defaultPointOfServiceName,
        'lastCartId': value.lastCartId,
        'hasOrder': value.hasOrder,
        'userAvatar': UserAvatarToJSON(value.userAvatar),
        'orgUnit': B2BUnitToJSON(value.orgUnit),
        'roles': value.roles,
        'approvers': value.approvers === undefined ? undefined : ((value.approvers as Array<any>).map(UserToJSON)),
        'selected': value.selected,
        'active': value.active,
        'email': value.email,
        'ssn': value.ssn,
        'type': value.type,
        'municipalityId': value.municipalityId,
        'phone': value.phone,
        'customerType': value.customerType,
        'contactAddress': AddressToJSON(value.contactAddress),
        'positiveListAvailable': value.positiveListAvailable,
        'customerStatGroup1': value.customerStatGroup1,
        'customerStatGroup2': value.customerStatGroup2,
        'market': value.market,
        'allowOnetimeAddress': value.allowOnetimeAddress,
        'orgUnits': value.orgUnits === undefined ? undefined : ((value.orgUnits as Array<any>).map(B2BUnitToJSON)),
    };
}

